define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';


	// public methods

	function normalize(str) {
		var x500Array = new Array(),
			entries,
			entry,
			i;

		if (!Util.isValidString(str)) {
			return null;
		}

		entries = str.split(',');

		for (i = 0; i < entries.length; i++) {
			entry = entries[i].split('=');

			if (entry.length !== 2) {
				return null;
			}

			x500Array.push(entry[0].trim().toUpperCase() + '=' + entry[1].trim());
		}

		return x500Array.sort().join(',');
	}

	function compare(str1, str2) {
		return (normalize(str1) === normalize(str2));
	}


	return {
		normalize : normalize,
		compare : compare
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/X500Util.js
// module id = 73
// module chunks = 6